module.exports = __webpack_public_path__ + "static/media/couple_walking.60bb6583.png";